import makeRoutes from "@/routes/Base/Route";

export default makeRoutes('corecareunits').map(route => {
    return {
        ...route,
        meta: {perfil: 'root'}
    }
})